import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/login'], resolve),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/view/user/register'], resolve),
      meta: {
        title: '注册'
      }
    },
    {
      path: '/findPassword',
      name: 'findPassword',
      component: resolve => require(['@/view/user/findPassword'], resolve),
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/Home'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/assessment',
          name: 'assessment',
          component: resolve => require(['@/view/assessment/index'], resolve),
          meta: {
            title: '专利申请前评估'
          }
        },
        {
          path: '/hosting',
          name: 'hosting',
          component: resolve => require(['@/view/user/hosting'], resolve),
          meta: {
            title: '专利托管管理'
          }
        },
        {
          path: '/user',
          name: 'user',
          component: resolve => require(['@/view/user/index'], resolve),
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/innovationPlatform/lifeScience',
          name: 'LifeSciencePlatform',
          component: resolve => require(['@/view/InnovationPlatform/lifeScience'], resolve),
          meta: {
            title: '良渚生命科学平台'
          }
        }, {
          path: '/innovationPlatform/digitalCulturalCreative',
          name: 'DigitalCulturalCreative',
          component: resolve => require(['@/view/InnovationPlatform/digitalCulturalCreative'], resolve),
          meta: {
            title: '良渚数字文化创意平台'
          }
        }, {
          path: '/innovationPlatform/industrialDesign',
          name: 'IndustrialDesign',
          component: resolve => require(['@/view/InnovationPlatform/industrialDesign'], resolve),
          meta: {
            title: '良渚工业设计平台'
          }
        },
        // {
        //   path: '/innovationPlatform',
        //   name: 'InnovationPlatform',
        //   component: resolve => require(['@/view/InnovationPlatform'], resolve),
        //   meta: {
        //     title: '良渚创新平台'
        //   },
        //   children: [
        //     {
        //       path: '/lifeScience',
        //       name: 'LifeSciencePlatform',
        //       component: resolve => require(['@/view/InnovationPlatform/lifeScience'], resolve),
        //       meta: {
        //         title: '良渚生命科学平台'
        //       }
        //     }, {
        //       path: '/digitalCulturalCreative',
        //       name: 'DigitalCulturalCreative',
        //       component: resolve => require(['@/view/InnovationPlatform/digitalCulturalCreative'], resolve),
        //       meta: {
        //         title: '良渚数字文化创意平台'
        //       }
        //     }, {
        //       path: '/industrialDesign',
        //       name: 'IndustrialDesign',
        //       component: resolve => require(['@/view/InnovationPlatform/industrialDesign'], resolve),
        //       meta: {
        //         title: '良渚工业设计平台'
        //       }
        //     }
        //   ]
        // },
        {
          path: '/seaService',
          name: 'SeaService',
          component: resolve => require(['@/view/seaService'], resolve),
          meta: {
            title: '出海服务'
          }
        },
        {
          path: '/idc',
          name: 'IDC',
          component: resolve => require(['@/view/IDC'], resolve),
          meta: {
            title: '数据中心'
          }
        }, {
          path: '/officeHall',
          name: 'OfficeHall',
          component: resolve => require(['@/view/OfficeHall'], resolve),
          meta: {
            title: '办事大厅'
          },
          children: [
            {
              path: 'hallIntroduction',
              meta: { title: '大厅介绍'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/hallIntroduction'),
            }, {
              path: 'workGuide',
              meta: { title: '办事指南'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/workGuide'),
            }, {
              path: 'oneStopService',
              meta: { title: '一站式办理'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/oneStopService'),
            },  {
              path: 'chargeFree',
              meta: { title: '免费服务'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/chargeFree'),
            }, {
              path: 'rapidPatentPreTrial',
              meta: { title: '专利快速预审'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/rapidPatentPreTrial'),
            }, {
              path: 'iprCustody',
              meta: { title: '知识产权托管'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/iprCustody'),
            }, {
              path: 'iprFinancialService',
              meta: { title: '知识金融服务'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/iprFinancialService'),
            }, {
              path: 'serviceOnline',
              meta: { title: '服务在线'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/serviceOnline'),
            }, {
              path: 'popularizationOfRightsProtection',
              meta: { title: '维权普及'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/popularizationOfRightsProtection'),
            }, {
              path: 'rightsProtectionAssistance',
              meta: { title: '维权援助'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/rightsProtectionAssistance'),
            }, {
              path: 'complaint',
              meta: { title: '平台投诉'},
              component: () => import(/* webpackChunkName: "officeHall" */'@/view/OfficeHall/complaint'),
            }
          ]
        }, {
          path: '/policyInformation',
          name: 'PolicyInformation',
          component: resolve => require(['@/view/PolicyInformation'], resolve),
          meta: {
            title: '政策资讯'
          }
        }, {
          path: '/propertyFair',
          name: 'PropertyFair',
          component: resolve => require(['@/view/propertyFair'], resolve),
          meta: {
            title: '知识产权交易'
          }
        }, {
          path: '/iprClass',
          name: 'IprClass',
          component: resolve => require(['@/view/IprClass'], resolve),
          meta: {
            title: '知识产权课堂'
          }
        }, {
          path: '/brandGuidance',
          name: 'BrandGuidance',
          component: resolve => require(['@/view/BrandGuidance'], resolve),
          meta: {
            title: '品牌指导'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}//savedPosition也是一个记录x轴和y轴位置的对象
	},
})



// WEBPACK FOOTER //
// ./src/router/index.js